<div
  class="holder h-100 position-relative"
  (click)="selectList.emit(list.id)"
  [attr.data-list-name]="list.name"
>
  <div class="header">
    <h1 class="h1 d-flex">
      <div class="base-details">
        <span class="title w-100 d-inline-block summarized-text">{{ list.name }}</span>
        <p class="default-paragraph mt-3 records" *ngIf="list.items.length > 0">
          {{ list.items.length }} list item{{ list.items.length > 1 ? 's' : '' }}
        </p>
        <p class="default-paragraph mt-3 records" *ngIf="!list.items.length">No list items</p>
      </div>
      <div class="ml-auto">
        <label
          *ngIf="!listIsDeployed"
          class="
            default-label
            thumbnail-selector
            d-flex
            position-absolute
            align-items-end
            justify-content-end
          "
          (click)="$event.stopPropagation()"
        >
          <input
            type="checkbox"
            class="mb-3 d-block"
            (change)="changeSelectedState.emit({ listId: list.id, selected: $event.target.checked })"
            [checked]="selected ? 'checked' : null"
          />
        </label>
        <i
          *ngIf="listIsDeployed"
          class="fa fa-info-circle deployed-info"
          [ngbPopover]="deployedListInfo"
          placement="bottom"
          container="body"
          triggers="mouseenter:mouseleave"
        ></i>
      </div>
    </h1>
  </div>
  <ul class="items list-unstyled">
    <li *ngFor="let item of list.items.slice(0, maxVisibleItems)" class="summarized-text">
      {{ item.value || 'No item name' }}
    </li>
  </ul>
  <button class="p-0 more btn btn-link" *ngIf="list.items.length > maxVisibleItems">...</button>
</div>

<ng-template #deployedListInfo> This is a deployed list </ng-template>
